import React from 'react';

import {SCOPE_KEY} from 'src/modules/profile/user/tabs/content/workspace/util';
import {WorkspaceRequestSortBy} from 'src/openapi/admin/models/WorkspaceRequest';

import {SortHeaderWithDataTable} from '@pb/kit-component-sort-header';
import {Cell} from '@pb/kit-component-table';

import {uiToApiSort} from '../../utils/util';
import {useWorkspaceCriteria} from '../hooks/useWorkspaceCriteria';

export const LastUpdatedHeader = () => {
    const {criteria, setCriteria: onUpdate} = useWorkspaceCriteria(SCOPE_KEY);

    return (
        <Cell width={138} className="nowrap">
            <SortHeaderWithDataTable
                caption="Last Updated Date"
                defaultDirection="DESC"
                direction={criteria?.sortBy === WorkspaceRequestSortBy.LAST_MODIFIED_DATE
                    ? criteria.sortDirection
                    : undefined}
                onSort={dir => onUpdate({
                    sortDirection: uiToApiSort(dir),
                    sortBy: WorkspaceRequestSortBy.LAST_MODIFIED_DATE,
                })}
            />
        </Cell>
    );
};
